<template>
  <div class="row contact-form">
    <div class="col-md-8 contact-form__wrapper">
      <div class="cform" id="contact-form">
         <!--
        <div id="sendmessage">
          <p>
            <button type="button" class="close">
              <span aria-hidden="true">&times;</span>
              <span class="sr-only">Close</span>
            </button>
            Tu mensaje se ha enviado con &eacute;xito.¡Gracias!
          </p>
        </div>
          -->
        <v-form v-model="valid">
          <v-container>
            <v-layout row wrap>
              <v-flex
                  xs12
                  md4
              >
                <v-text-field
                  v-model="name"
                  :error-messages="namesErrors"
                  :counter="15"
                  :label="$t('contact_form_label_name')"
                  required
                  @input="$v.name.$touch()"
                  @blur="$v.name.$touch()"
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                md4
              >
              <v-text-field
                v-model="email"
                :error-messages="emailErrors"
                :label="$t('contact_form_label_email')"
                required
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
              ></v-text-field>
              </v-flex>

              <v-flex
                xs12
                md4
              >
              <v-text-field
                v-model="subject"
                :label="$t('contact_form_label_subject')"
                :counter="20"
                :error-messages="subjectErrors"
                @input="$v.subject.$touch()"
                @blur="$v.subject.$touch()"
              ></v-text-field>
              </v-flex>

              <input
                type="hidden"
                name="recaptcha_response"
                id="recaptchaResponse"
              >

              <v-flex xs12
                md12>
                <v-textarea
                  name="message"
                  :label="$t('contact_form_label_message')"
                  v-model="message"
                  :error-messages="messageErrors"
                  value=""
                  hint=""
                  :counter="255"
                  @input="$v.message.$touch()"
                  @blur="$v.message.$touch()"
                ></v-textarea>
            </v-flex>
            <v-flex xs12 md12
            >
              <v-checkbox
                v-model="terms"
                :error-messages="termsErrors"
                label="Es necesario que aceptes nuestra politica de privacidad."
                required
              >
              <template v-slot:label>
                <div>
                 {{ $t('policy_text_check1') }}
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <router-link to="/legales/politica-de-privacidad">
                        {{ $t('policy_text_check2') }}
                      </router-link>
                    </template>
                  </v-tooltip>
                  {{ $t('policy_text_check3') }}
                </div>
              </template>
              </v-checkbox>
                <v-btn @click="submit">{{$t('contact_form_btn')}}</v-btn>
            </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </div>
    </div>
    <!-- ./span12 -->
    <Modal
      :title="$t('message_sended_success')"
      :message="$t('modal_contact_info')"
      v-bind:visible="showConfirmationModal"
    >
    </Modal>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength, email } from 'vuelidate/lib/validators'
import Modal from '@/components/Modal.vue'

import axios from 'axios'

export default {
  components: {
    Modal
  },
  mixins: [validationMixin],
  name: 'ContactForm',
  validations: {
    name: { required, maxLength: maxLength(15) },
    subject: { maxLength: maxLength(20) },
    email: { required, email },
    message: { required, maxLength: maxLength(255) },
    terms: {
      checked (val) {
        return val
      }
    }
  },
  data: () => ({
    valid: false,
    name: '',
    email: '',
    message: '',
    subject: '',
    terms: false,
    recaptchaKey: '6Lc2iKkUAAAAABNhyWAQ6EzTTfqGkOtwkKoROfoU',
    showConfirmationModal: false
  }),
  created () {
    window.grecaptcha.ready(function () {
      window.grecaptcha.execute('6Lc2iKkUAAAAABNhyWAQ6EzTTfqGkOtwkKoROfoU', { action: 'message' })
        .then(function (token) {
          var recaptchaResponse = document.getElementById('recaptchaResponse')
          recaptchaResponse.value = token
        })
    })
  },
  computed: {
    termsErrors () {
      const errors = []
      if (!this.$v.terms.$dirty) return errors
      !this.$v.terms.checked && errors.push('Debes aceptar la polictica de privacidad')
      return errors
    },
    messageErrors () {
      const errors = []
      if (!this.$v.message.$dirty) return errors
      !this.$v.message.required && errors.push('Debes escribir un mensaje')
      !this.$v.message.maxLength && errors.push('El mensaje no puede sobrepasar los 255 caracteres')
      return errors
    },
    namesErrors () {
      const errors = []
      if (!this.$v.name.$dirty) return errors
      !this.$v.name.maxLength && errors.push('El nombre no debe tener más de 15 caracteres')
      !this.$v.name.required && errors.push('El nombre es obligatorio.')
      return errors
    },
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Debes introducir un email válido.')
      !this.$v.email.required && errors.push('El email es obligatorio.')
      return errors
    },
    subjectErrors () {
      const errors = []
      if (!this.$v.subject.$dirty) return errors
      !this.$v.subject.maxLength && errors.push('El asunto no puede superar los 20 caracteres.')
      return errors
    }
  },
  methods: {
    submit () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        var self = this
        axios
          .post('/contact/contact.php', {
            name: this.$v.name.$model,
            email: this.$v.email.$model,
            subject: this.$v.subject.$model,
            message: this.$v.message.$model,
            recaptcha_response: document.getElementById('recaptchaResponse').value
          })
          .then(function (response) {
            if (response.data.code === 200) {
              self.resetForm()
              self.hideModal()
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    resetForm () {
      this.$v.name.$model = ''
      this.$v.email.$model = ''
      this.$v.subject.$model = ''
      this.$v.message.$model = ''
      this.$v.$reset()
    },
    hideModal () {
      this.showConfirmationModal = true
    }
  }
}
</script>

<style lang='less'>
  .v-label {
    font-family: inherit;
    font-weight: normal!important;
    font-size: 0.8em!important;
    color: #38477F!important;
  }

  .contact-form {
    &__wrapper {
      margin: 0 auto;
    }
  }

  .contact-form.row {
    margin-top: -65px;
  }

  .contact-form input[type=checkbox] {
    -moz-appearance: checkbox;
    -webkit-appearance: checkbox;
    -ms-appearance: checkbox;
    appearance: checkbox;
  }

  .theme--light {
    color: #38477F!important;
    caret-color: #38477F!important;
  }

  .error--text {
    color: #ff5252 !important;
    caret-color: #ff5252 !important;
  }

  .recaptcha-container {
    margin-left: 0.8em;
  }

</style>
